import * as OrganisationInfo from '../../partials/OrganisationInfo';
import * as CustomerOrganisationContacts from '../../partials/CustomerOrganisationContacts';
import * as IntermediaryOrganisationContacts from '../../partials/IntermediaryOrganisationContacts';
import * as Terms from '../../partials/Terms';
import * as SubmitForm from '../../partials/SubmitForm';
import * as DataExchangeLayerInformation from '../../partials/DataExchangeLayerInformation';
import * as ApiCatalogueContactInformation from '../../partials/ApiCatalogueContactInformation';

export const initialSteps = [
  {
    id: 0,
    title: OrganisationInfo.formTitle,
    titleIntermediary: OrganisationInfo.formTitleIntermediary,
    completed: false,
    Form: OrganisationInfo.Form,
    schema: OrganisationInfo.schema(false),
    intermediarySchema: OrganisationInfo.schema(true)
  },
  {
    id: 1,
    title: CustomerOrganisationContacts.formTitle,
    titleIntermediary: CustomerOrganisationContacts.formTitleIntermediary,
    completed: false,
    Form: CustomerOrganisationContacts.Form,
    schema: CustomerOrganisationContacts.schema(false),
    intermediarySchema: CustomerOrganisationContacts.schema(true)
  },
  {
    id: 2,
    title: IntermediaryOrganisationContacts.formTitle,
    completed: false,
    Form: IntermediaryOrganisationContacts.Form,
    schema: IntermediaryOrganisationContacts.schema(),
    intermediaryOnly: true
  },
  {
    id: 3,
    title: DataExchangeLayerInformation.formTitle,
    completed: false,
    Form: DataExchangeLayerInformation.Form,
    schema: DataExchangeLayerInformation.schema
  },
  {
    id: 4,
    title: ApiCatalogueContactInformation.formTitle,
    completed: false,
    Form: ApiCatalogueContactInformation.Form,
    schema: ApiCatalogueContactInformation.schema
  },
  {
    id: 5,
    title: Terms.formTitle,
    completed: false,
    Form: Terms.Form,
    schema: Terms.schema
  },
  {
    id: 6,
    title: 'intermediary.common.send',
    completed: false,
    Form: SubmitForm.Form,
    schema: SubmitForm.schema
  }
];
